/** @format */

/* eslint require-await: "warn" */
import { AxiosResponse } from 'axios';

import { SubmissionErrorCode } from '@toucan/common/services/application/constants';

import { client } from '@toucan/client/global/axios';

export async function getCsrfToken() {
    return client.get('/_csrf');
}

export async function getCsrfTokenValue() {
    const response = await getCsrfToken();
    return response?.data?.csrfToken ?? '';
}

export const isInvalidCSRFResponse = (response: any): boolean =>
    response?.data?.code === SubmissionErrorCode.INVALID_CSRF;

export function rejectIfInvalidCSRFResponse(response: AxiosResponse) {
    if (isInvalidCSRFResponse(response)) {
        return Promise.reject(response);
    }

    return response;
}
